import axios from "axios";
export const state = {
    expense_categories: [],
    expenses: [],
    expense_report: [],
    expense_save_status: false,
    expense_items:[],
    match_status:false
};
export const getters = {
    ExpenseCategories: state => state.expense_categories.data,
    Expenses: state => state.expenses.data,
    ExpenseSaveStatus: state => state.expense_save_status,
    ExpenseItems:state => state.expense_items.data,
    Match_Status:state => state.match_status,

};

export const mutations = {
    SET_EXPENSE_CATEGORIES: (state, newValue) => state.expense_categories = newValue,
    SET_EXPENSES: (state, newValue) => state.expenses = newValue,
    SET_EXPENSE_STATUS:(state, newValue) =>  state.expense_save_status = newValue,
    SET_EXPENSES_ITEMS:( state, newValue) =>state.expense_items = newValue,
    SET_MATCH_STATUS:( state, newValue) =>state.match_status = newValue
};

export const actions = {
    addExpenseCategory({ commit, dispatch }, payload) {
        // console.log(payload);
        commit('SET_EXPENSE_STATUS', true);
        axios.post('expense_categories', payload).then(() => {
            dispatch('fetchExpenseCategories');
            let message = { 'msg': "Expense Category added successfully" }
                // DISPATCH MESSAGE MODULE
            dispatch('notification/success', message, { root: true })
            commit('SET_EXPENSE_STATUS', false);
        }).catch((eror) => {
            if (eror.response.status == 401) {
                dispatch('auth/logout', null, { root: true })
            }
            commit('SET_EXPENSE_STATUS', false)
            let message = { 'msg': "Error Adding Category" }
            dispatch('notification/error', message, { root: true })
        })

    },
    // Edit expense category
    editExpenseCategory({ commit, dispatch }, payload) {
        commit('SET_EXPENSE_STATUS', true);
        axios.put(`expense_categories/${payload.id}`, payload).then(() => {
            dispatch('fetchExpenseCategories');
            let message = { 'msg': "Expense Category updated successfully" }
                // DISPATCH MESSAGE MODULE
            dispatch('notification/success', message, { root: true })
            commit('SET_EXPENSE_STATUS', false);
        }).catch((eror) => {
            if (eror.response.status == 401) {
                dispatch('auth/logout', null, { root: true })
            }
            commit('SET_EXPENSE_STATUS', false)
            let message = { 'msg': "Error updating Category" }
            dispatch('notification/error', message, { root: true })
        })
    },
    // Delete expense category
    deleteExpenseCategory({ commit, dispatch }, payload) {
        // console.log(payload);
        commit('SET_EXPENSE_STATUS', true);
        axios.delete(`expense_categories/${payload.id}`).then(() => {
            dispatch('fetchExpenseCategories');
            let message = { 'msg': "Expense Category deleted successfully" }
                // DISPATCH MESSAGE MODULE
            dispatch('notification/success', message, { root: true })
            commit('SET_EXPENSE_STATUS', false);
        }).catch((eror) => {
            if (eror.response.status == 401) {
                dispatch('auth/logout', null, { root: true })
            }
            commit('SET_EXPENSE_STATUS', false)
            let message = { 'msg': "Error deleting Category" }
            dispatch('notification/error', message, { root: true })
        })
    },

    // add expenditure
    recordExpense({ commit, dispatch }, payload) {
        // console.log(payload);
        commit('SET_EXPENSE_STATUS', true);
        axios.post('expenses', payload).then(() => {
            dispatch('fetchExpenses');
            let message = { 'msg': "Expense added successfully" }
                // DISPATCH MESSAGE MODULE
            dispatch('notification/success', message, { root: true })
            commit('SET_EXPENSE_STATUS', false);
        }).catch((eror) => {
            if (eror.response.status == 401) {
                dispatch('auth/logout', null, { root: true })
            }
            commit('SET_EXPENSE_STATUS', false)
            let message = { 'msg': "Error Adding Expense" }
            dispatch('notification/error', message, { root: true })
        })
    },

    // Edit expense
    editExpenses({ commit, dispatch }, payload) {
        commit('SET_EXPENSE_STATUS', true);
        axios.put(`expenses/${payload.id}`, payload).then(() => {
            dispatch('fetchExpenses');
            let message = { 'msg': "Expense updated successfully" }
                // DISPATCH MESSAGE MODULE
            dispatch('notification/success', message, { root: true })
            commit('SET_EXPENSE_STATUS', false);
        }).catch((eror) => {
            if (eror.response.status == 401) {
                dispatch('auth/logout', null, { root: true })
            }
            commit('SET_EXPENSE_STATUS', false)
            let message = { 'msg': "Error updating Expense" }
            dispatch('notification/error', message, { root: true })
        })
    },

    // clear expense
    clearExpenses({ commit, dispatch }, payload) {
        commit('SET_EXPENSE_STATUS', true);
        axios.put(`clear_expenses/${payload.id}`, payload).then(() => {
            dispatch('fetchExpenses');
            let message = { 'msg': "Expense cleared successfully" }
                // DISPATCH MESSAGE MODULE
            dispatch('notification/success', message, { root: true })
            commit('SET_EXPENSE_STATUS', false);
        }).catch((eror) => {
            if (eror.response.status == 401) {
                dispatch('auth/logout', null, { root: true })
            }
            commit('SET_EXPENSE_STATUS', false)
            let message = { 'msg': "Error clearing Expense" }
            dispatch('notification/error', message, { root: true })
        })
    },
    // Delete expense 
    deleteExpense({ commit, dispatch }, payload) {
        commit('SET_EXPENSE_STATUS', true);
        axios.delete(`expenses/${payload.id}`).then(() => {
            dispatch('fetchExpenses');
            let message = { 'msg': "Expenditure deleted successfully" }
                // DISPATCH MESSAGE MODULE
            dispatch('notification/success', message, { root: true })
            commit('SET_EXPENSE_STATUS', false);
        }).catch((eror) => {
            if (eror.response.status == 401) {
                dispatch('auth/logout', null, { root: true })
            }
            commit('SET_EXPENSE_STATUS', false)
            let message = { 'msg': "Error Deleting Expenditure" }
            dispatch('notification/error', message, { root: true })
        })
    },

    fetchExpenseCategories({ commit, dispatch }) {
        axios.get('expense_categories').then(ec_res => {
            commit('SET_EXPENSE_CATEGORIES', ec_res.data)
        }).catch((eror) => {
            if (eror.response.status == 401) {
                dispatch('auth/logout', null, { root: true })
            }
        })
    },
    fetchExpenses({ commit, dispatch }) {
        axios.get('expenses').then(e_res => {
            commit('SET_EXPENSES', e_res.data)
        }).catch((eror) => {
            if (eror.response.status == 401) {
                dispatch('auth/logout', null, { root: true })
            }
        })
    },
    fetchExpenseItems({ commit, dispatch }){
          axios.get('expense_items').then(e_res => {
            commit('SET_EXPENSES_ITEMS', e_res.data)
        }).catch((eror) => {
            if (eror.response.status == 401) {
                dispatch('auth/logout', null, { root: true })
            }
        })
    },
    matchExpenseCategory({ commit, dispatch },payload){
          commit('SET_MATCH_STATUS', true)
        axios.put(`match_expense_cat/${payload.item_id}`,payload).then(() => {
           commit('SET_MATCH_STATUS', false)
             dispatch('fetchExpenseItems');
              let message = { 'msg': "Match done successfully" }
                // DISPATCH MESSAGE MODULE
            dispatch('notification/success', message, { root: true })
            commit('SET_EXPENSE_STATUS', false);
        }).catch((eror) => {

            if (eror.response.status == 401) {
                dispatch('auth/logout', null, { root: true })
            }
              let message = { 'msg': "Error matching Category" }
            dispatch('notification/error', message, { root: true })
        })
    },
addExpenseItem({ commit, dispatch },payload){
  commit('SET_EXPENSE_STATUS', true);
        axios.post('expense_items', payload).then(() => {
            dispatch('fetchExpenseItems');
            let message = { 'msg': "Expense Item added successfully" }
                // DISPATCH MESSAGE MODULE
            dispatch('notification/success', message, { root: true })
            commit('SET_EXPENSE_STATUS', false);
        }).catch((eror) => {
            if (eror.response.status == 401) {
                dispatch('auth/logout', null, { root: true })
            }
            commit('SET_EXPENSE_STATUS', false)
            let message = { 'msg': "Error Adding Item" }
            dispatch('notification/error', message, { root: true })
        })
},
editExpenseItem({ commit, dispatch },payload){
      commit('SET_EXPENSE_STATUS', true);
        axios.put(`expense_items/${payload.id}`, payload).then(() => {
            dispatch('fetchExpenseItems');
            let message = { 'msg': "Expense Item updated successfully" }
                // DISPATCH MESSAGE MODULE
            dispatch('notification/success', message, { root: true })
            commit('SET_EXPENSE_STATUS', false);
        }).catch((eror) => {
            if (eror.response.status == 401) {
                dispatch('auth/logout', null, { root: true })
            }
            commit('SET_EXPENSE_STATUS', false)
            let message = { 'msg': "Error updating Item" }
            dispatch('notification/error', message, { root: true })
        }) 
},
deleteExpenseItem({ commit, dispatch },payload){
     commit('SET_EXPENSE_STATUS', true);
        axios.delete(`expense_items/${payload.id}`).then(() => {
            dispatch('fetchExpenseItems');
            let message = { 'msg': "Expense Item deleted successfully" }
                // DISPATCH MESSAGE MODULE
            dispatch('notification/success', message, { root: true })
            commit('SET_EXPENSE_STATUS', false);
        }).catch((eror) => {
            if (eror.response.status == 401) {
                dispatch('auth/logout', null, { root: true })
            }
            commit('SET_EXPENSE_STATUS', false)
            let message = { 'msg': "Error Deleting Item" }
            dispatch('notification/error', message, { root: true })
        })
}

};